import React from 'react';
import type { AsOfDateSetting } from 'venn-utils';

export type AllocationAsOfDateDropdownContextValue = {
  mutations: {
    setAllocationsAsOfDate: (asOfDate: AsOfDateSetting) => void;
    closeDropdownPanel: () => void;
  };
};

const defaultAllocationAsOfDateDropdownContextValue: AllocationAsOfDateDropdownContextValue = {
  mutations: {
    setAllocationsAsOfDate: () => {
      throw new Error('setAllocationAsOfDate is not implemented');
    },
    closeDropdownPanel: () => {
      throw new Error('closeDropdownPanel is not implemented');
    },
  },
};

export const AllocationAsOfDateDropdownContext = React.createContext<AllocationAsOfDateDropdownContextValue>(
  defaultAllocationAsOfDateDropdownContextValue,
);
AllocationAsOfDateDropdownContext.displayName = 'AllocationAsOfDateDropdownContext';
